import { render, staticRenderFns } from "./DictDataModal.vue?vue&type=template&id=aee05fc2&scoped=true"
import script from "./DictDataModal.vue?vue&type=script&lang=js"
export * from "./DictDataModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee05fc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aee05fc2')) {
      api.createRecord('aee05fc2', component.options)
    } else {
      api.reload('aee05fc2', component.options)
    }
    module.hot.accept("./DictDataModal.vue?vue&type=template&id=aee05fc2&scoped=true", function () {
      api.rerender('aee05fc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/DictDataModal.vue"
export default component.exports